import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

import { Icon } from "@proda-ai/ui-kit";
import React from "react";

export type ProgressBarProps = Omit<BoxProps, "children"> & {
    label?: React.ReactNode;
    subLabel?: React.ReactNode;
    progressPercentage: number;
};

const testId = "ProgressBar";
const ProgressBar = (props: ProgressBarProps) => {
    const {
        sx,
        label,
        subLabel,
        progressPercentage,
        className,
        ...otherProps
    } = props;

    const completed = progressPercentage === 100;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            sx={{
                width: "100%",
                borderRadius: "5px",
                overflow: "hidden",
                marginTop: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "left",
                fontWeight: 400,
                fontSize: "16px",
                color: "var(--proda-black-10)",
                ...sx,
            }}
            {...otherProps}
        >
            <Box
                component={"p"}
                className="file-name-container"
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "16px",
                }}
            >
                {label}
                {completed ? (
                    <Icon icon="check" color="var(--accent-color)" />
                ) : null}
            </Box>
            <Box
                className="progress-bar-outer"
                sx={{
                    position: "relative",
                    backgroundColor: "var(--proda-white-130)",
                    height: "10px",
                    borderRadius: "5px",
                    maxWidth: "100%",
                }}
            >
                <Box
                    className="progress-bar-inner"
                    sx={{
                        width: `${progressPercentage}%`,
                        position: "absolute",
                        left: 0,
                        top: 0,
                        height: "10px",
                        borderRadius: "5px",
                        transition: "width 0.3s",
                        maxWidth: "100%",
                        backgroundColor: "var(--accent-color)",
                    }}
                ></Box>
                <Box
                    className="progress-bar-inner"
                    sx={{
                        width: "100%",
                        position: "absolute",
                        left: 0,
                        top: 0,
                        height: "10px",
                        borderRadius: "5px",
                        transition: "width 0.3s",
                        maxWidth: "100%",
                        backgroundColor: "transparent",
                    }}
                ></Box>
            </Box>
            <Box
                id="progress-bar-number"
                sx={{
                    display: "flex",
                    marginBottom: "16px",
                }}
            >
                <p>
                    {completed
                        ? "Saving File..."
                        : subLabel !== undefined && subLabel !== null
                          ? subLabel
                          : progressPercentage === 0
                            ? "Processing File..."
                            : `${progressPercentage}%`}
                </p>
            </Box>
        </Box>
    );
};

export default ProgressBar;
